<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'

// One titled card on the property-detail screen. Every card on every tab is one
// of these, so the headings, the chrome and the spacing can't drift apart — and
// the chrome matches the request detail's cards, which sit one click away.
defineProps<{ title: string; subtitle?: string | null }>()
</script>

<template>
  <Box is="section" direction="col" gap="4" class="section">
    <Box flex align="start" justify="between" gap="3">
      <Box direction="col" gap="0.125rem" class="section__heading">
        <Text is="h2" type="heading" weight="semibold">{{ title }}</Text>
        <Text v-if="subtitle" type="caption">{{ subtitle }}</Text>
      </Box>
      <slot name="aside" />
    </Box>

    <slot />
  </Box>
</template>

<style scoped>
.section {
  padding: 1.5rem;
  border: 1px solid var(--p-content-border-color);
  border-radius: var(--p-border-radius-xl);
  background: var(--p-surface-0);
}

.section__heading {
  min-width: 0;
}

@media (max-width: 992px) {
  .section {
    padding: 1rem;
  }
}
</style>
